import { useTranslation } from 'react-i18next';
import { RecordAttendanceButton } from './styles';
import { i18nNS } from '../../../../../../i18n';
import useRecordAttendanceAction from './vm';
import RecordAttendanceDrawer from './RecordAttendanceDrawer';

const RecordAttendanceAction = () => {
  const { t } = useTranslation([i18nNS.CLASS]);
  const { isOpen, handleClickRecordAttendance, handleCloseDrawer } = useRecordAttendanceAction();

  return (
    <>
      <RecordAttendanceButton size="large" onClick={handleClickRecordAttendance} fullWidth>
        {t('record_attendance', { ns: i18nNS.CLASS })}
      </RecordAttendanceButton>
      <RecordAttendanceDrawer open={isOpen} onClose={handleCloseDrawer} />
    </>
  );
};

export default RecordAttendanceAction;
